import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard, PrepareGuard, PendingChangesGuard } from 'app/core/core.module';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { PicturesEntryComponent } from './pictures-entry/pictures-entry.component';
import { PicturesOverviewComponent } from './pictures-overview/pictures-overview.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'pictures',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'entry', pathMatch: 'full' },
                    { path: 'overview', component: PicturesOverviewComponent, data: { title: 'Pictures Overview' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'pack-slips', component: PicturesEntryComponent, data: { title: 'Pictures', mode: 'PackingSlip' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'invoices', component: PicturesEntryComponent, data: { title: 'Pictures', mode: 'Invoice' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'sales-orders', component: PicturesEntryComponent, data: { title: 'Pictures', mode: 'SalesOrder' }, canActivate: [AuthGuard, PrepareGuard] },
                ],
            },
        ]),
    ],
    declarations: [PicturesEntryComponent, PicturesOverviewComponent],
})
export class PicturesModule {}
